import React from 'react';

import { cn } from '@/lib/utils';
import Dislike from '@/svgs/thumbsDown.svg';

type Props = {
  dislike: number;
  active?: boolean;
  isLoading?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  color?: string;
};

const DislikeLesson: React.FC<Props> = ({
  dislike,
  active,
  onClick,
  isLoading,
  disabled,
  color = 'black',
}) => {
  return (
    <div
      className="flex gap-1.5 items-center"
      onClick={(e) => {
        if (onClick && !disabled) {
          e.stopPropagation();
          onClick();
        }
      }}
    >
      <div className="w-[13px] h-[13px] flex items-center justify-center">
        <Dislike
          style={{ color: color === 'white' ? color : '#1967DE' }}
          className={cn(
            color === 'white'
              ? {
                  'fill-white animate-pulse': isLoading,
                  'fill-white': active,
                }
              : {
                  'fill-[#1967DE] animate-pulse': isLoading,
                  'fill-[#1967DE]': active,
                }
          )}
        />
      </div>
      <p className={` text-tiny pt-0.5 text-${color}`}>{dislike}</p>
    </div>
  );
};

export default DislikeLesson;
